import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Simple in-memory cache to avoid refetching same seller's rating repeatedly
const ratingCache = new Map();

export const useSellerRating = (sellerId) => {
  const [rating, setRating] = useState(ratingCache.get(sellerId) || null);

  useEffect(() => {
    if (!sellerId) return;

    if (ratingCache.has(sellerId)) {
      setRating(ratingCache.get(sellerId));
      return;
    }

    let cancelled = false;
    const fetchRating = async () => {
      try {
        const { data } = await axios.get(`${API}/reviews/seller/${sellerId}/summary`);
        if (!cancelled) {
          ratingCache.set(sellerId, data);
          setRating(data);
        }
      } catch (error) {
        // fail silently
      }
    };

    fetchRating();
    return () => { cancelled = true; };
  }, [sellerId]);

  return rating || { average_rating: 0, total_reviews: 0 };
};

// Utility to clear the cache when a review is submitted
export const clearRatingCache = (sellerId) => {
  if (sellerId) {
    ratingCache.delete(sellerId);
  } else {
    ratingCache.clear();
  }
};
